<template>
    <div class="content" :style="{'direction': $vs.rtl ? 'rtl' : 'ltr','text-align':'left'}">
      <span v-show="rowStatus" class="new">NEW</span> <span>{{cellValue}}</span>
    </div>
</template>

<script>

export default {
  name: 'CellRendererTitle',
  data: function () {
    return {
      cellValue: '',
      rowStatus: false,
    };
  },
  methods: {

  },
  beforeMount() {
    this.rowStatus = !!this.params.data.last_update_status;
    this.cellValue = this.params.valueFormatted ? this.params.valueFormatted : this.params.value;
  },
}
</script>

<style lang="scss" scoped>
  .content {
    position: relative;
    padding-top: 5px;
    padding-bottom: 0px;
    .new {
      color: #fff;
      width: 50px;
      height: 10px;
      padding: 3px;
      margin-right: 3px;
      background-color: #e53935;
      border-top-right-radius: 4px;
      border-top-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
</style>